export const enum ENTITY {
  EDIFICIO_MIRADOR = "edificio-mirador",
  CARLOS_MOROS = "carlos-moros",
  FUNDACION = "fundacion",
  ESPACIO_1 = "espacio-1",
  ESPACIO_2 = "espacio-2",
  INFO = "info",
}

export enum CONTENT_TYPE {
  ASSETS = "assets",
  AUDIO = "audio",
  REDIRECT = "redirect",
  POST = "post",
  BLOG = "noticias",
}

export interface IContent {
  name: string;
  value: CONTENT_TYPE;
}
